import { lazy } from 'react';

const edit = lazy(() => import('./Edit'));

export default {
  edit,
};
